import styled from 'styled-components';

import { Container } from '@pb/shared/ui/atoms/container';

export const StyledContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const SpinnerContainer = styled.div`
    width: 100%;
    height: 100%;
`;

// https://web.archive.org/web/20211026084610/https://newbedev.com/prevent-flex-item-from-exceeding-parent-height-and-make-scroll-bar-work
export const StyledWrapper = styled.div`
    flex: 1 1 0.1rem;
    align-content: center;
    align-self: stretch;
    overflow: hidden;
    border-top: 0.1rem solid ${({ theme }) => theme.color.grey5};
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey5};

    @media (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        display: flex;
        grid-template-columns: 2fr 3fr;
        margin: 0 1.5rem;
        border: 0.1rem solid ${({ theme }) => theme.color.grey5};
        border-radius: ${({ theme }) => theme.borderRadius.default};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.l.min}) {
        grid-template-columns: 1fr 3fr;
    }
`;

export const StyledHeader = styled.header`
    grid-area: header;
    padding: 1.6rem 1.5rem;

    @media (min-width: 76.8rem) {
        padding: 2.4rem 1.5rem;
    }

    @media (min-width: 99.2rem) {
        padding: 3.2rem 1.5rem;
    }
`;

export const StyledNav = styled.nav`
    display: block;
    width: 100%;
    height: 100%;
    overflow-y: auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.m.min}) {
        width: 28rem;
        border-right: 0.1rem solid ${({ theme }) => theme.color.grey5};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.l.min}) {
        width: 38.4rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.xl.min}) {
        width: 44rem;
    }
`;

export const StyledUl = styled.ul`
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
`;

export const StyledThreadWrapper = styled.div`
    width: 100%;
`;
